import { render, staticRenderFns } from "./person-bvd.html?vue&type=template&id=9ac15a62&scoped=true&"
import script from "./person-bvd.js?vue&type=script&lang=js&"
export * from "./person-bvd.js?vue&type=script&lang=js&"
import style0 from "./person-bvd.scss?vue&type=style&index=0&id=9ac15a62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac15a62",
  null
  
)

export default component.exports